import React, { Component } from 'react';
import { Button } from 'antd';
import HOCWorkflow from './HOCWorkflow';

class Opration extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <span>
        <Button
          icon="check"
          type="primary"
          style={{ marginRight: 10 }}
          onClick={() => this.props.doTask('next')}
          loading={this.props.isLoading || false}
        >
          通过
        </Button>
      </span>
    );
  }
}

export default HOCWorkflow(Opration);



// WEBPACK FOOTER //
// ./src/components/comm/workflow/WorkflowOp.js